module.exports = __webpack_public_path__ + "static/media/bg-lines-2.dec37f08.png";